export const SET_PATHWAYS = 'App - Set Pathways';
export const SET_CURRENT_PATHWAY = 'App - Set Current Pathway';
export const SET_INITIAL_LOADING = 'App - Set Initial Loading';
export const SET_KEYCLOAK_INSTANCE = 'App - Set Keycloak Instance';
